import * as React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { Backdrop } from '@mui/material'
import { useCustomContext } from '../../Context'
import { useTheme } from '@mui/material/styles'

export default function SimpleBackdrop({ loader }: { loader: boolean }) {
  const { initialState } = useCustomContext()
  const { loading } = initialState
  const theme = useTheme()

  return (
    <div>
      <Backdrop
        sx={{ color: theme.custom.darkAccentPrimaryColor, zIndex: theme.zIndex.drawer + 1 }}
        open={loading || loader}
      >
        <CircularProgress sx={{ color: theme.custom.darkBackgroundPrimaryAccentColor }} />
      </Backdrop>
    </div>
  )
}
